import React from 'react';
import '../../styles/styles.css';

export default function kollur() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/Mookambika.jpg" alt="Mookambika Amman" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Important Festival Dates<br />
    Dussehra Navaratri<br />    
    <br />

  </strong></p>
  <p>Temple Official Details Website : <a href="https://kollurmookambikatemple.org/" target="_blank" rel="noopener noreferrer">
  Mookambika Temple Website
</a>
  </p></div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Kollur Mookambika Temple has been an abode of Devi Shakthi's worship for centuries. The statue of Mookambike is very attractive and has four arms. The upper two arms are holding Shankha and Chakra and the palms of the lower two arms are held as blessing the devotees with the Abhaya and Varada Hastha. In an ancient inscription (dated 1481 A D) found here, the source of the Shakthi has been described. Shree Mookambika Devi in the form of Linga is the Adi Shakthi, the Creator and the protector of all forms of life. A troll or monster known as Kaumhasura, wanted to get a boon from God Shiva, that, he should not get death from any living being. To disable him from asking the boon Vagdevi makes him dumb. Accordingly he became Mookasura or Dumb troll. Due to this, Mookaasura became furious and wanted to take revenge against the Gods. The Gods could not withstand the trouble imparted by him and sought refuge from Devi. In response the Devi had integrated the powers of the Trimurthis and all the Gods into her to put the Mookasura to death and after that, assimilated into the Linga and now exists known as Mookambike and protects her devotees. </p>
           </div>
        </div>
  

    <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Kollur Mookambika Temple</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/8fhU_zgefZI?rel=0&modestbranding=1&showinfo=0"
                title="Kollur Mookambika Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>

  </div>
</div>
</div>
  )
}
